import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export const ThemeToggle = () => {
  const { theme, changeTheme } = useTheme();

  const themes = [
    { value: 'light', icon: Sun, label: 'Hell' },
    { value: 'dark', icon: Moon, label: 'Dunkel' },
    { value: 'auto', icon: Monitor, label: 'Auto' }
  ];

  return (
    <div className="flex gap-1.5">
      {themes.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          onClick={() => changeTheme(value)}
          className={`flex items-center justify-center gap-1 px-2 py-1 rounded-md transition-all ${
            theme === value
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'bg-muted hover:bg-muted/80 text-muted-foreground hover:text-foreground'
          }`}
          title={label}
        >
          <Icon className="h-3 w-3" />
          <span className="text-[10px] font-medium">{label}</span>
        </button>
      ))}
    </div>
  );
};
